import { Fragment, useMemo } from "react"

import cls from "classname"

import Icon from "../../../../../Icon"
import { MONTH_SEGMENTS } from "../monitoringCopy"
import { getMetricLegend } from "../monthCellLines"
import MonthPopover from "../MonthPopover/MonthPopover"

import "./MonthStrip.less"

const MonthStrip = ({
  program,
  timeline = [],
  year,
  currentMonth,
  thresholds,
  region,
  renderCell,
  isMobile = false
}) => {
  const segments = useMemo(() => {
    const closed = { key: "closed", label: MONTH_SEGMENTS.closed, months: [] }
    const inProgress = { key: "inProgress", label: MONTH_SEGMENTS.inProgress, months: [] }
    const notStarted = { key: "notStarted", label: MONTH_SEGMENTS.notStarted, months: [] }

    const liveYear = currentMonth?.year
    const liveMonth = currentMonth?.month

    timeline.forEach((month) => {
      if (liveYear == null || year == null || year < liveYear) {
        closed.months.push(month)
        return
      }

      if (year > liveYear) {
        notStarted.months.push(month)
        return
      }

      if (month.month < liveMonth) closed.months.push(month)
      else if (month.month === liveMonth) inProgress.months.push(month)
      else notStarted.months.push(month)
    })

    return [closed, inProgress, notStarted].filter((segment) => segment.months.length > 0)
  }, [timeline, year, currentMonth?.year, currentMonth?.month])

  const isLiveYear = year != null && year === currentMonth?.year

  const legend = getMetricLegend(program)

  if (!timeline.length) return null

  return (
    <div className={cls("month-strip-block", { "is-mobile": isMobile })}>
      <div className={cls("month-strip", { "is-mobile": isMobile })}>
        {segments.map((segment, index) => (
          <Fragment key={segment.key}>
            {index > 0 && <div className="month-strip__divider" />}
            {/* Each segment claims one unit of width per month it holds, so a cell is the same width
              in every segment and a one-month segment stays exactly one cell wide. */}
            <div
              className={cls("month-strip__segment", segment.key)}
              style={{ flex: `${segment.months.length} 1 0` }}
            >
              <div className="month-strip__label">{segment.label}</div>
              <div className="month-strip__months">
                {/* The popover node is handed to the cell, which anchors it on the status icon —
                  the only clickable element in a cell (§3 R11). */}
                {segment.months.map((month) =>
                  renderCell(month, {
                    popover: (
                      <MonthPopover
                        program={program}
                        month={month}
                        thresholds={thresholds}
                        region={region}
                        isFutureMonth={
                          currentMonth?.year == null || year == null
                            ? false
                            : year > currentMonth.year ||
                              (isLiveYear && month.month > currentMonth.month)
                        }
                      />
                    )
                  })
                )}
              </div>
            </div>
          </Fragment>
        ))}
      </div>

      <div className="month-strip-block__legend">
        {legend.map(({ key, icon, label }) => (
          <span key={key} className="month-strip-block__legend-item">
            <Icon type={icon} />
            {label}
          </span>
        ))}
      </div>
    </div>
  )
}

export default MonthStrip
